import { createContext, useContext } from 'react';

export interface BundleInterviewContextValue {
  bundleSlug: string;
}

/**
 * Optional context BundleScriptView provides when wrapping <ClientInterviewView/>
 * inside a shoot-kind bundle (see docs/script-bundles-plan.md §5 "Shoot pack").
 * Presence alone tells ClientInterviewView it's rendering inside the dark,
 * read-only shoot pack rather than being opened from a standalone /s/:slug
 * review page — it forces the dark theme and swaps its header for the
 * bundle-appropriate copy. Absent for the standalone /s/:slug/interview
 * route, which must render identically to today.
 */
export const BundleInterviewContext = createContext<BundleInterviewContextValue | null>(null);

export function useBundleInterview(): BundleInterviewContextValue | null {
  return useContext(BundleInterviewContext);
}
